var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Climate = function Climate(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      d: "M4.38281 6.98438C3.07031 8.29688 3.07031 10.3969 4.38281 11.7094L11.9953 19.3219L16.7203 14.5969L9.10781 6.98438C7.79531 5.67188 5.69531 5.67188 4.38281 6.98438Z",
      fill: "none",
      opacity: "0.4"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      d: "M17.2459 12.6734C19.0822 12.6734 20.5709 11.1848 20.5709 9.34844C20.5709 7.51209 19.0822 6.02344 17.2459 6.02344C15.4096 6.02344 13.9209 7.51209 13.9209 9.34844C13.9209 11.1848 15.4096 12.6734 17.2459 12.6734Z",
      fill: "none"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      d: "M6.7459 12.6734C8.58225 12.6734 10.0709 11.1848 10.0709 9.34844C10.0709 7.51209 8.58225 6.02344 6.7459 6.02344C4.90955 6.02344 3.4209 7.51209 3.4209 9.34844C3.4209 11.1848 4.90955 12.6734 6.7459 12.6734Z",
      fill: "none"
    }))]
  });
};
export default Climate;